import cookies from "./cookies"
import * as urlHandler from "./url"
import * as request from "./request"

/**
 * 微信相关
 * @param {String} opt.appid 业务的offerid
 * @param {String} opt.context 授权会带过去
 * @param {Boolean} opt.forceOAuth 每次都强制跳授权。默认是false
 * @param {String} opt.openid 用户的openid
 * @param {String} opt.accessToken 用户的accessToken
 * @param {String} opt.scope 权限scope=snsapi_base,snsapi_userinfo
 * @param {Int} opt.getDetail 1为获取用户信息
 */
var wechat = function (opt) {
  opt = opt || {}

  /**
   * 公众号的appid
   */
  this.appid = opt.appid || wechat.defaultAppid

  /**
   * 上下文，授权会带过去
   */
  this.context = opt.context || "wechat_oauth"

  /**
   * 每次都强制跳授权。默认是false
   */
  this.forceOAuth = ~~opt.forceOAuth

  /**
   * 用户的openid
   */
  this.openid = opt.openid || null

  //微信的scope权限scope=snsapi_base,snsapi_userinfo
  this.scope = opt.scope || "snsapi_base"

  /**
   * 用户的accessToken
   */
  this.accessToken = opt.accessToken || null

  /**
   * 授权返回的code
   */
  this.code = urlHandler.getParam("code")

  /**
   * refresh_token存储在cookie里的key
   */
  this.refreshTokenKey = this.appid + "rt"

  /**
   * 1为获取用户信息
   */
  this.getDetail = opt.getDetail || ""

  if (this.getDetail == 1) {
    this.scope = "snsapi_userinfo"
  }

  var _t

  if ((_t = opt.code) || ((_t = urlHandler.getParam("code")) && this.context == urlHandler.getParam("state"))) {
    //如果url中有code，就标记为CODE
    this._code = _t
    this.type = TYPE.CODE
  } else if (~~opt.forceOAuth) {
    //如果强制授权的，就需要授权NEED_OAUTH
    this.type = TYPE.NEED_OAUTH
  } else if (cookies.get(this.refreshTokenKey)) {
    //如果cookie中有refresht_token就标记为MY_REFRESH_TOKEN
    this._refresh_token = cookies.get(this.refreshTokenKey)
    this.type = TYPE.MY_REFRESH_TOKEN
  } else {
    //其他标记为NEED_OAUTH
    this.type = TYPE.NEED_OAUTH
  }
}

wechat.defaultAppid = "wx951bdcac522929b6"
//授权的模式
var TYPE = (wechat.TYPE = {
  //跳授权取code的模式
  CODE: 1,

  //自己种的refresh_token
  MY_REFRESH_TOKEN: 2,

  //需要跳授权
  NEED_OAUTH: 4
})
wechat.prototype = {
  /**
   * init后就能调用getOpenid取用户的openid了
   * @param {Function} opt.onSuccess 能取到code或者refresh_token的成功回调
   * @param {Function} opt.onBeforeOAuth 如果取不到code或者refresh_token就会去跳授权。return false可以阻止跳授权
   * @param {String} opt.isNotInWechat 微信场景获取授权还是移动浏览器场景获取授权
   * @param {String} opt.redirectUrl 指定授权回调地址
   */
  init: function (opt) {
    opt = opt || {}
    //先判断能否取用户的openid信息
    if (this.type === TYPE.NEED_OAUTH) {
      if (!opt.onBeforeOAuth || opt.onBeforeOAuth.call(this) === true) {
        this.oAuth(opt)
      }
      return false
    } else {
      opt.onSuccess && opt.onSuccess.call(this)
      return true
    }
  },
  /**
   * 获取openid
   * @param {Function} opt.onSuccess 成功回调
   * @param {Function} opt.onExpire code或者refresh_token过期了。默认会去跳授权。return false可以阻止跳授权
   * @param {Function} opt.onError 失败回调
   * @param {String} opt.isNotInWechat 微信场景获取授权还是移动浏览器场景获取授权
   * @param {String} opt.redirectUrl 指定授权回调地址
   */
  getOpenid: function (opt) {
    opt = opt || {}
    if (this.type === TYPE.NEED_OAUTH) {
      return false
    }

    var that = this,
      response,
      res

    //SSI的支持。如果是CODE模式
    if (window._wxinfo !== undefined) {
      response = window._wxinfo
    } else if (this.type === TYPE.CODE && window._wxinfo1 !== undefined) {
      response = window._wxinfo1
    } else if (this.type === TYPE.MY_REFRESH_TOKEN && window._wxinfo2 !== undefined) {
      response = window._wxinfo2
    }

    if (response) {
      try {
        res = eval("(" + response + ")")
      } catch (e) {
        /* eslint no-empty:"off"*/
      }
    }
    //有ssi数据
    if (res) {
      handler(res)
    } else if (!opt.sync) {
      //非同步模式下去请求cgi
      var param = {
        code: this.type === TYPE.CODE ? this._code : "",
        refresh_token: this.type === TYPE.MY_REFRESH_TOKEN ? encodeURIComponent(this._refresh_token) : "",
        appid: this.appid,
        get_detail: this.getDetail,
        r: Math.random()
      }

      //请求cgi
      request
        .ajax({
          url: "//pay.qq.com/cgi-bin/account/get_wechat_userinfo.cgi",
          data: param
        })
        .then(
          response => {
            handler(response)
          },
          () => {
            opt.onError &&
              opt.onError.call(that, {
                ret: 2
              })
          }
        )
    } else {
      throw new Error("We need get_wechat_userinfo response!")
    }

    function handler(response) {
      var res = response
      if (res) {
        //请求成功
        if (!~~res.resultcode && res.resultinfo) {
          var userInfo = res.resultinfo
          that.openid = userInfo.obj.openid
          that.accessToken = userInfo.obj.access_token
          that.info = userInfo.obj

          // 若用户返回的 scope 是 snsapi_userinfo ，且没有返回 snsapi_baseinfo, 手动将 baseinfo 权限加上，避免重复跳授权
          let userScope = userInfo.obj.scope
          if (userScope.indexOf("snsapi_userinfo") > -1 && userScope.indexOf("snsapi_base") === -1) {
            userInfo.obj.scope = `${userScope},snsapi_base`
          }

          //缓存的refresh_token要看是否和当前要求scope匹配，如果不匹配、这个时候应该重新让用户授权,不能继续使用此access_token
          // if (that.type === TYPE.MY_REFRESH_TOKEN && that.scope === "snsapi_userinfo" && userInfo.obj.scope.indexOf(that.scope) === -1) {
          //   opt.onSuccess && opt.onSuccess.call(that)
          //   that.oAuth(opt)
          //   return
          // }

          //CODE模式保存refresh_token到cookie
          if (that.type === TYPE.CODE) {
            //将refresh_token存入cookie,10年有效期
            cookies.set(that.refreshTokenKey, userInfo.obj.refresh_token || "", {})
          }

          opt.onSuccess && opt.onSuccess.call(that)
        } else if (~~res.resultcode === 12271) {
          //过期
          //如果是缓存的refresh_token。需要删掉他，避免下次进来还用到他
          if (that.type === TYPE.MY_REFRESH_TOKEN) {
            that.delRefreshToken()
          }

          if (opt.onExpire && opt.onExpire.call(that) === false) {
          } else {
            that.oAuth(opt)
          }
        } else if (~~res.resultcode === 12273) {
          //获取用户信息失败

          if (that.type === TYPE.MY_REFRESH_TOKEN) {
            that.delRefreshToken()
            //如果缓存的refresh_token获取用户信息失败了，去跳授权
            that.oAuth(opt)
          } else {
            opt.onError && opt.onError.call(that, res)
          }
          //授权拿到的code不是snsapi_useinfo，给他重新跳授权也没用
        } else {
          that.delRefreshToken()
          opt.onError && opt.onError.call(that, res)
        }
      } else {
        opt.onError && opt.onError.call(that)
      }
    }
  },
  delRefreshToken: function () {
    cookies.set(this.refreshTokenKey, "", { domain: "qq.com", time: -3600 })
    cookies.set(this.refreshTokenKey, "", { time: -3600 })
  },
  /**
   * 跳授权
   */
  oAuth: function (opt) {
    let url =
      "//open.weixin.qq.com/" +
      (opt.isNotInWechat ? "sns/explorer_broker?" : "connect/oauth2/authorize?") +
      "appid=" +
      this.appid +
      "&redirect_uri=" +
      encodeURIComponent(urlHandler.delParam(["code", "state"], opt.redirectUrl || location.href)) +
      "&response_type=code" +
      "&scope=" +
      this.scope +
      "&state=" +
      this.context +
      "#wechat_redirect"

    location.href = url
  },
  api: function (apiName, opt, cfn) {
    //如果因为没权限，最多调用50次
    var maxCount = 10,
      count = 0
    var invoke = function () {
      count++
      WeixinJSBridge.invoke(apiName, opt, function (res) {
        if (res.err_msg === "system:access_denied" || res.err_msg === "access_control:not_allow") {
          if (count <= maxCount) {
            setTimeout(function () {
              invoke()
            }, 200)
          } else {
            cfn && cfn.call(this, res)
          }
        } else {
          cfn && cfn.call(this, res)
        }
      })
    }
    if (window.WeixinJSBridge) {
      invoke()
    } else {
      document.addEventListener("WeixinJSBridgeReady", function () {
        if (window.WeixinJSBridge) {
          invoke()
        }
      })
    }
  },
  buy: function (opt, info) {
    var self = this
    setTimeout(function () {
      self.api(
        "getBrandWCPayRequest",
        {
          appId: info.wx_appid.toString(), //公众号名称，由商户传入
          timeStamp: info.wx_time.toString(), //时间戳这里随意使用了一个值
          nonceStr: info.wx_noncenum.toString(), //随机串
          package: info.wx_package.toString(), //扩展字段，由商户传入
          signType: info.wx_signtype.toString(), //微信签名方式:sha1
          paySign: info.wx_sign.toString() //微信签名
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            //用户购买成功
            opt.onSuccess && opt.onSuccess()
          } else {
            //失败
            opt.onError && opt.onError(res)
          }
        }
      )
    }, 100)
  }
}

export default wechat
